import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DEMO_NOTIFICATIONS } from '../data/demo';
import { FiArrowLeft, FiHeart, FiMessageCircle, FiStar, FiZap } from 'react-icons/fi';

const iconMap = {
  like: { icon: <FiHeart size={14} />, color: '#FF3D71', bg: '#FF3D7115' },
  match: { icon: <FiZap size={14} />, color: '#8B5CF6', bg: '#8B5CF615' },
  message: { icon: <FiMessageCircle size={14} />, color: '#3B82F6', bg: '#3B82F615' },
  superlike: { icon: <FiStar size={14} />, color: '#F59E0B', bg: '#F59E0B15' },
};

const textMap = {
  like: (u) => `${u} liked you`,
  match: (u) => `You matched with ${u}!`,
  message: (u, t) => `${u}: ${t}`,
  superlike: (u) => `${u} super liked you`,
};

const Notifications = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 90 }}>
      <div style={{ padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#A1A1AA', cursor: 'pointer' }}>
          <FiArrowLeft size={22} />
        </button>
        <h1 style={{ fontSize: 22, fontWeight: 700 }}>Notifications</h1>
      </div>

      <div style={{ padding: '0 16px' }}>
        {DEMO_NOTIFICATIONS.map(n => {
          const config = iconMap[n.type] || iconMap.like;
          return (
            <div key={n._id} style={{
              display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px',
              marginBottom: 4, borderRadius: 14,
              background: n.read ? 'transparent' : 'rgba(255,61,113,0.04)',
              border: `1px solid ${n.read ? 'transparent' : 'rgba(255,61,113,0.08)'}`,
              transition: 'all 0.2s',
            }}>
              <div style={{
                width: 44, height: 44, borderRadius: 14, overflow: 'hidden', position: 'relative', flexShrink: 0,
              }}>
                <img src={n.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${n.user}&background=1A1A24&color=FF3D71`; }} />
                <div style={{
                  position: 'absolute', bottom: -2, right: -2,
                  width: 20, height: 20, borderRadius: 7,
                  background: config.bg, border: '2px solid #08080C',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: config.color,
                }}>{config.icon}</div>
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 14, color: n.read ? '#A1A1AA' : '#FFFFFF', fontWeight: n.read ? 400 : 500 }}>
                  {textMap[n.type](n.user, n.text)}
                </p>
                <p style={{ fontSize: 12, color: '#52525B', marginTop: 2 }}>{n.time}</p>
              </div>
              {!n.read && <div style={{ width: 8, height: 8, borderRadius: 4, background: '#FF3D71' }} />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Notifications;
